import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Tours = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    people: '2',
    message: '',
    includeBuffet: false,
    includeCatacion: true,
    includeRecorrido: true
  });

  const [activeTab, setActiveTab] = useState('info');

  // Imágenes desde Unsplash para evitar errores de compilación mientras agregas las tuyas locales
  const bosqueImg = "https://images.unsplash.com/photo-1473081556163-2a17de81fc97?auto=format&fit=crop&w=800&q=80";
  const fincaImg = "https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?auto=format&fit=crop&w=800&q=80";
  const cataImg = "https://images.unsplash.com/photo-1497935586351-b67a49e012bf?auto=format&fit=crop&w=800&q=80";
  const xicotepecImg = "https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&w=1920&q=80";
  const procesadoraImg = "https://images.unsplash.com/photo-1611162458324-aae1eb4129a4?auto=format&fit=crop&w=800&q=80";
  const cocinaHumoImg = "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?auto=format&fit=crop&w=800&q=80";
  const romanImg = "https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=800&q=80";

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const numPersonas = parseInt(formData.people);
    // REGLA: Cobro mínimo de 4 personas para recorridos y catación
    const personasParaCobro = Math.max(4, numPersonas);

    const costoCatacion = formData.includeCatacion ? 200 * personasParaCobro : 0;
    const costoRecorrido = formData.includeRecorrido ? 150 * personasParaCobro : 0;
    const costoTourCompleto = formData.includeCatacion && formData.includeRecorrido ? 300 * personasParaCobro : costoCatacion + costoRecorrido;
    const costoBuffet = formData.includeBuffet && numPersonas >= 10 ? 200 * numPersonas : 0;
    const costoTotal = costoTourCompleto + costoBuffet;

    let mensaje = `¡Gracias por tu interés en visitar nuestra finca!\n\n`;
    mensaje += `📍 **Xicotepec de Juárez, Pueblo Mágico**\n`;
    mensaje += `🌲 **Sierra Norte de Puebla**\n\n`;
    mensaje += `📋 **RESUMEN DE TU RESERVACIÓN**\n`;
    mensaje += `━━━━━━━━━━━━━━━━━━━━━━━━\n\n`;
    mensaje += `👤 Nombre: ${formData.name}\n`;
    mensaje += `📧 Email: ${formData.email}\n`;
    mensaje += `📞 Teléfono: ${formData.phone}\n`;
    mensaje += `📅 Fecha: ${formData.date || 'Por definir'}\n`;
    mensaje += `👥 Personas asistiendo: ${numPersonas}\n`;
    mensaje += `⚠️ Cobro de Tour aplicado por mínimo de: ${personasParaCobro} personas\n\n`;
    
    mensaje += `💰 **DETALLE DE COSTOS**\n`;
    mensaje += `━━━━━━━━━━━━━━━━━━\n`;
    if (formData.includeCatacion && !formData.includeRecorrido) {
      mensaje += `🎫 Taller de Catación: $${costoCatacion} MXN\n`;
    }
    if (formData.includeRecorrido && !formData.includeCatacion) {
      mensaje += `🌿 Recorrido por el cafetal: $${costoRecorrido} MXN\n`;
    }
    if (formData.includeCatacion && formData.includeRecorrido) {
      mensaje += `🎟️ Tour Completo (ahorro): $${costoTourCompleto} MXN\n`;
    }
    
    if (formData.includeBuffet) {
      if (numPersonas >= 10) {
        mensaje += `🍽️ Cocina Tradicional de Humo: $${costoBuffet} MXN\n`;
      } else {
        mensaje += `⚠️ Cocina de humo no incluida (mínimo 10 personas)\n`;
      }
    }
    
    mensaje += `\n💵 **TOTAL ESTIMADO: $${costoTotal} MXN**\n\n`;
    mensaje += `━━━━━━━━━━━━━━━━━━━━━━━━\n`;
    mensaje += `Te contactaremos en máximo 24 horas para confirmar disponibilidad.\n`;
    mensaje += `\n¡Gracias por elegir Román Valderrábano El Catador! ☕`;

    alert(mensaje);
    console.log('Tour reservado:', formData);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const toursDisponibles = [
    {
      id: 1,
      nombre: 'Tour Completo',
      duracion: '4 horas',
      incluye: ['Recorrido por cafetal en bosque mesófilo', 'Taller de catación con Q Grader', 'Degustación de 5 cafés', 'Recuerdo artesanal'],
      precio: 300,
      imagen: fincaImg,
      disponible: true
    },
    {
      id: 2,
      nombre: 'Solo Recorrido',
      duracion: '2 horas',
      incluye: ['Recorrido por cafetal', 'Explicación del proceso', 'Degustación básica'],
      precio: 150,
      imagen: bosqueImg,
      disponible: true
    },
    {
      id: 3,
      nombre: 'Taller de Catación',
      duracion: '1.5 horas',
      incluye: ['Taller con Román Valderrábano, El Catador', 'Cata de 5 variedades', 'Certificado de participación'],
      precio: 200,
      imagen: cataImg,
      disponible: true
    },
    {
      id: 4,
      nombre: 'Cocina Tradicional de Humo',
      duracion: '2 horas',
      incluye: ['Experiencia en ollas de barro', 'Técnicas ancestrales de humo', 'Maridaje con cafés', 'Postre especial'],
      precio: 200,
      imagen: cocinaHumoImg,
      disponible: true,
      minimo: 10
    }
  ];

  return (
    <>
      <style>{`
        :root {
          --primary-color: #8B4513;
          --primary-hover: #A0522D;
          --secondary-color: #D2B48C;
          --dark-bg: #1A1A1A;
          --light-bg: #F9F6F0;
          --text-main: #2C2C2C;
          --text-light: #666666;
          --white: #FFFFFF;
          --radius-md: 12px;
          --radius-lg: 24px;
          --shadow-sm: 0 4px 6px rgba(0, 0, 0, 0.05);
          --shadow-md: 0 10px 30px rgba(0, 0, 0, 0.08);
          --shadow-lg: 0 20px 40px rgba(0, 0, 0, 0.12);
          --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .tours-page {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          background-color: var(--light-bg);
          color: var(--text-main);
          min-height: 100vh;
        }

        /* HERO SECTION */
        .tours-hero {
          position: relative;
          height: 60vh;
          min-height: 450px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: var(--white);
          overflow: hidden;
          background-size: cover;
          background-position: center;
        }

        .tours-hero-overlay {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: linear-gradient(to bottom, rgba(26,26,26,0.6), rgba(26,26,26,0.9));
          z-index: 1;
        }

        .tours-hero-content {
          position: relative;
          z-index: 2;
          max-width: 800px;
          padding: 0 2rem;
        }

        .tours-hero h1 {
          font-family: 'Playfair Display', serif;
          font-size: 3.5rem;
          margin-bottom: 1rem;
        }

        .tours-hero p {
          font-size: 1.2rem;
          color: #E0E0E0;
          margin-bottom: 1.5rem;
        }

        .hero-location {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          margin-bottom: 2rem;
          color: var(--secondary-color);
          font-weight: 600;
          letter-spacing: 1px;
        }

        .btn-gold {
          background-color: var(--secondary-color);
          color: var(--dark-bg);
          padding: 1rem 2.5rem;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 700;
          font-size: 1.1rem;
          border: none;
          cursor: pointer;
          transition: var(--transition);
        }

        .btn-gold:hover {
          background-color: var(--white);
          transform: translateY(-3px);
        }

        /* TABS NAVIGATION */
        .tours-tabs {
          display: flex;
          justify-content: center;
          gap: 1rem;
          background: var(--white);
          padding: 1rem 5%;
          box-shadow: var(--shadow-sm);
          position: sticky;
          top: 0;
          z-index: 50;
          flex-wrap: wrap;
        }

        .tab-btn {
          background: transparent;
          border: none;
          padding: 1rem 1.5rem;
          font-size: 1.05rem;
          font-weight: 600;
          color: var(--text-light);
          cursor: pointer;
          position: relative;
          transition: var(--transition);
          font-family: inherit;
        }

        .tab-btn:hover {
          color: var(--primary-color);
        }

        .tab-btn.active {
          color: var(--primary-color);
        }

        .tab-btn.active::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 10%;
          width: 80%;
          height: 3px;
          background-color: var(--primary-color);
          border-radius: 3px 3px 0 0;
        }

        .tabs-content {
          padding: 4rem 5%;
          max-width: 1200px;
          margin: 0 auto;
        }

        /* INFORMACIÓN TAB */
        .tours-info-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4rem;
          align-items: center;
        }

        .tours-info-text h2 {
          font-family: 'Playfair Display', serif;
          font-size: 2.5rem;
          color: var(--dark-bg);
          margin-bottom: 1.5rem;
        }

        .tours-info-text p {
          color: var(--text-light);
          line-height: 1.8;
          font-size: 1.05rem;
          margin-bottom: 1rem;
        }

        .tours-highlights {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1.5rem;
          margin-top: 2.5rem;
        }

        .highlight-item {
          background: var(--white);
          padding: 1.5rem;
          border-radius: var(--radius-md);
          box-shadow: var(--shadow-sm);
          border: 1px solid rgba(139, 69, 19, 0.1);
        }

        .highlight-icon {
          font-size: 2rem;
          display: block;
          margin-bottom: 0.5rem;
        }

        .highlight-item h4 {
          color: var(--dark-bg);
          margin-bottom: 0.5rem;
          font-size: 1.1rem;
        }

        .highlight-item p {
          font-size: 0.9rem;
          margin: 0;
        }

        .tours-quote {
          margin-top: 3rem;
          padding-left: 2rem;
          border-left: 4px solid var(--primary-color);
        }

        .tours-quote blockquote {
          font-family: 'Playfair Display', serif;
          font-size: 1.25rem;
          font-style: italic;
          margin: 0 0 1rem 0;
          color: var(--dark-bg);
        }

        .tours-quote cite {
          font-weight: 700;
          color: var(--primary-color);
        }

        .tours-info-image {
          position: relative;
          border-radius: var(--radius-lg);
          overflow: hidden;
          box-shadow: var(--shadow-lg);
        }

        .tours-info-image img {
          width: 100%;
          height: auto;
          display: block;
        }

        .image-badge {
          position: absolute;
          bottom: 20px;
          left: 20px;
          background: rgba(26, 26, 26, 0.9);
          color: var(--white);
          padding: 0.8rem 1.5rem;
          border-radius: 50px;
          font-size: 0.9rem;
          backdrop-filter: blur(5px);
          display: flex;
          align-items: center;
          gap: 10px;
        }

        /* TOURS DISPONIBLES TAB */
        .tours-available-section h2 {
          font-family: 'Playfair Display', serif;
          font-size: 2.5rem;
          text-align: center;
          margin-bottom: 0.5rem;
          color: var(--dark-bg);
        }

        .tours-available-section > p {
          text-align: center;
          color: var(--text-light);
          margin-bottom: 3rem;
        }

        .tours-cards-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 2.5rem;
        }

        .tour-card {
          background: var(--white);
          border-radius: var(--radius-md);
          overflow: hidden;
          box-shadow: var(--shadow-md);
          display: flex;
          flex-direction: column;
          transition: var(--transition);
          border: 1px solid rgba(0,0,0,0.05);
        }

        .tour-card:hover {
          transform: translateY(-10px);
          box-shadow: var(--shadow-lg);
          border-color: var(--secondary-color);
        }

        .tour-card-image {
          position: relative;
          height: 200px;
        }

        .tour-card-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .tour-minimo-badge {
          position: absolute;
          top: 15px;
          right: 15px;
          background: #E57373;
          color: white;
          padding: 0.3rem 0.8rem;
          font-size: 0.8rem;
          font-weight: bold;
          border-radius: 20px;
        }

        .tour-card-content {
          padding: 1.5rem;
          display: flex;
          flex-direction: column;
          flex-grow: 1;
        }

        .tour-card-content h3 {
          font-family: 'Playfair Display', serif;
          font-size: 1.4rem;
          margin-bottom: 0.5rem;
          color: var(--dark-bg);
        }

        .tour-duracion {
          color: var(--primary-color);
          font-weight: 600;
          font-size: 0.9rem;
          margin-bottom: 1rem;
        }

        .tour-incluye {
          list-style: none;
          padding: 0;
          margin: 0 0 1.5rem 0;
          color: var(--text-light);
          font-size: 0.95rem;
          flex-grow: 1;
        }

        .tour-incluye li {
          margin-bottom: 0.5rem;
          padding-left: 1.2rem;
          position: relative;
        }
        
        .tour-incluye li::before {
          content: '✓';
          position: absolute;
          left: 0;
          color: var(--primary-color);
        }

        .tour-card-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-top: 1.5rem;
          border-top: 1px solid #EEE;
        }

        .tour-precio {
          font-size: 1.25rem;
          font-weight: 800;
          color: var(--dark-bg);
        }

        .btn-small {
          background: var(--dark-bg);
          color: var(--white);
          border: none;
          padding: 0.6rem 1.2rem;
          border-radius: var(--radius-md);
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
        }

        .btn-small:hover {
          background: var(--primary-color);
        }

        /* GALERÍA TAB */
        .tours-galeria-section h2 {
          font-family: 'Playfair Display', serif;
          font-size: 2.5rem;
          text-align: center;
          margin-bottom: 0.5rem;
        }
        .tours-galeria-section > p {
          text-align: center;
          color: var(--text-light);
          margin-bottom: 3rem;
        }

        .galeria-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 1.5rem;
        }

        .galeria-item {
          position: relative;
          border-radius: var(--radius-md);
          overflow: hidden;
          aspect-ratio: 4/3;
          box-shadow: var(--shadow-sm);
        }

        .galeria-item img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .galeria-item:hover img {
          transform: scale(1.08);
        }

        .galeria-caption {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);
          color: var(--white);
          padding: 2rem 1rem 1rem;
          font-weight: 600;
        }

        /* RESERVA TAB */
        .reserva-header {
          text-align: center;
          margin-bottom: 3rem;
        }

        .reserva-header h2 {
          font-family: 'Playfair Display', serif;
          font-size: 2.5rem;
          margin-bottom: 0.5rem;
        }

        .reserva-grid {
          display: grid;
          grid-template-columns: 1fr 1.5fr;
          gap: 3rem;
        }

        .info-card, .precios-card {
          background: var(--white);
          padding: 2rem;
          border-radius: var(--radius-md);
          box-shadow: var(--shadow-sm);
          margin-bottom: 1.5rem;
        }

        .info-card h3, .precios-card h3 {
          color: var(--primary-color);
          margin-bottom: 1rem;
          font-size: 1.2rem;
        }

        .info-card p, .info-card ul {
          color: var(--text-light);
          font-size: 0.95rem;
          margin-bottom: 1rem;
        }

        .info-card ul { padding-left: 0; list-style: none; }
        .info-card li { margin-bottom: 0.5rem; }

        .precio-item {
          display: flex;
          justify-content: space-between;
          padding: 0.8rem 0;
          border-bottom: 1px dashed #EEE;
          color: var(--text-main);
        }

        .precio-item .precio { font-weight: 700; color: var(--dark-bg); }
        .precio-item.highlight { color: var(--primary-color); font-weight: bold; }
        .precio-nota { font-size: 0.8rem; color: #E57373; margin-top: 1rem; }

        .reserva-form {
          background: var(--white);
          padding: 3rem;
          border-radius: var(--radius-lg);
          box-shadow: var(--shadow-md);
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1.5rem;
        }

        .form-group {
          margin-bottom: 1.5rem;
        }

        .form-group label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 600;
          font-size: 0.95rem;
        }

        .form-group input[type="text"],
        .form-group input[type="email"],
        .form-group input[type="tel"],
        .form-group input[type="date"],
        .form-group select,
        .form-group textarea {
          width: 100%;
          padding: 1rem;
          border: 1px solid #E0E0E0;
          border-radius: var(--radius-md);
          background: #FAFAFA;
          font-family: inherit;
          font-size: 1rem;
          transition: var(--transition);
        }

        .form-group input:focus, .form-group select:focus, .form-group textarea:focus {
          outline: none;
          border-color: var(--primary-color);
          box-shadow: 0 0 0 3px rgba(139, 69, 19, 0.1);
        }

        .checkbox-group {
          background: var(--light-bg);
          padding: 1rem 1.5rem;
          border-radius: var(--radius-md);
          border: 1px solid #E0E0E0;
        }

        .checkbox-label {
          display: flex;
          align-items: center;
          gap: 1rem;
          cursor: pointer;
          font-weight: normal !important;
          margin-bottom: 0 !important;
        }

        .checkbox-label input[type="checkbox"] {
          width: 20px;
          height: 20px;
          accent-color: var(--primary-color);
        }

        .tour-completo-info {
          background: #FFF3E0;
          color: #E65100;
          padding: 1rem 1.5rem;
          border-radius: var(--radius-md);
          font-weight: bold;
          margin-bottom: 1.5rem;
          border-left: 4px solid #E65100;
        }

        .form-warning {
          color: #D32F2F;
          font-size: 0.85rem;
          font-weight: bold;
          margin-top: 0.5rem;
          margin-left: 2.5rem;
        }

        .resumen-costos {
          background: var(--dark-bg);
          color: var(--white);
          padding: 2rem;
          border-radius: var(--radius-md);
          margin-bottom: 2rem;
        }

        .resumen-costos h4 {
          color: var(--secondary-color);
          margin-bottom: 1rem;
          font-size: 1.2rem;
          border-bottom: 1px solid rgba(255,255,255,0.1);
          padding-bottom: 0.5rem;
        }

        .resumen-costos p {
          display: flex;
          justify-content: space-between;
          margin-bottom: 0.5rem;
          color: #E0E0E0;
        }

        .resumen-costos .total {
          margin-top: 1rem;
          padding-top: 1rem;
          border-top: 1px solid rgba(255,255,255,0.2);
          font-size: 1.2rem;
          color: var(--white);
        }

        .btn-submit {
          width: 100%;
          background: var(--primary-color);
          color: var(--white);
          border: none;
          padding: 1.2rem;
          border-radius: var(--radius-md);
          font-size: 1.1rem;
          font-weight: bold;
          cursor: pointer;
          transition: var(--transition);
        }

        .btn-submit:hover {
          background: var(--primary-hover);
          transform: translateY(-2px);
        }

        @media (max-width: 968px) {
          .tours-info-grid, .reserva-grid { grid-template-columns: 1fr; }
          .form-row { grid-template-columns: 1fr; }
          .tours-hero h1 { font-size: 2.5rem; }
          .tours-tabs { justify-content: flex-start; overflow-x: auto; padding-bottom: 0; }
          .tab-btn { white-space: nowrap; }
          .reserva-form { padding: 1.5rem; }
        }
      `}</style>

      <div className="tours-page">
        {/* Hero Section */}
        <section className="tours-hero" style={{backgroundImage: `url(${xicotepecImg})`}}>
          <div className="tours-hero-overlay"></div>
          <div className="tours-hero-content">
            <h1>Conoce Nuestro Recorrido</h1>
            <p>Vive el fascinante mundo del café en la Sierra Norte de Puebla</p>
            <div className="hero-location">
              <span>📍 Xicotepec de Juárez, Pueblo Mágico</span>
              <span>🌲 Bosque Mesófilo de Montaña</span>
            </div>
            <button 
              className="btn-gold"
              onClick={() => {
                setActiveTab('reserva');
                setTimeout(() => {
                  document.getElementById('reserva-form')?.scrollIntoView({ behavior: 'smooth' });
                }, 100);
              }}
            >
              Reservar Ahora
            </button>
          </div>
        </section>

        {/* Tabs de navegación */}
        <div className="tours-tabs">
          <button 
            className={`tab-btn ${activeTab === 'info' ? 'active' : ''}`}
            onClick={() => setActiveTab('info')}
          >
            Información
          </button>
          <button 
            className={`tab-btn ${activeTab === 'tours' ? 'active' : ''}`}
            onClick={() => setActiveTab('tours')}
          >
            Tours Disponibles
          </button>
          <button 
            className={`tab-btn ${activeTab === 'galeria' ? 'active' : ''}`}
            onClick={() => setActiveTab('galeria')}
          >
            Galería
          </button>
          <button 
            className={`tab-btn ${activeTab === 'reserva' ? 'active' : ''}`}
            onClick={() => setActiveTab('reserva')}
          >
            Reservar
          </button>
        </div>

        {/* Contenido de tabs */}
        <div className="tabs-content">
          {/* Tab Información */}
          {activeTab === 'info' && (
            <section className="tours-info-section">
              <div className="tours-info-grid">
                <div className="tours-info-text">
                  <h2>Conoce Nuestra Finca en la Sierra Norte</h2>
                  <p>
                    Nos encontramos en las montañas de <strong>Xicotepec de Juárez, Pueblo Mágico</strong>, 
                    en la Sierra Norte de Puebla. Nuestra finca está enclavada en un 
                    <strong> bosque mesófilo de montaña</strong>, clima ideal para producir uno de los mejores cafés del país.
                  </p>
                  <p>
                    <strong>ROMÁN VALDERRÁBANO, EL CATADOR</strong>, te invita a conocer el proceso completo, desde 
                    la semilla hasta la taza, con la experiencia de 5 generaciones y su certificación como Q Grader.
                  </p>
                  
                  <div className="tours-highlights">
                    <div className="highlight-item">
                      <span className="highlight-icon">🌿</span>
                      <h4>Recorrido en Bosque Mesófilo</h4>
                      <p>Acompañados por guías especializados, conocerás el ecosistema único donde crece nuestro café</p>
                    </div>
                    <div className="highlight-item">
                      <span className="highlight-icon">👃</span>
                      <h4>Taller de Catación</h4>
                      <p>Aprende a identificar notas y aromas con un catador Q Grader certificado</p>
                    </div>
                    <div className="highlight-item">
                      <span className="highlight-icon">🏭</span>
                      <h4>Proceso de Tostado</h4>
                      <p>Descubre cómo transformamos el grano en café de especialidad</p>
                    </div>
                    <div className="highlight-item">
                      <span className="highlight-icon">🍽️</span>
                      <h4>Cocina Tradicional</h4>
                      <p>Degusta nuestra gastronomía en ollas de barro con técnicas ancestrales</p>
                    </div>
                  </div>

                  <div className="tours-quote">
                    <blockquote>
                      "Cada visita es única, compartimos nuestra pasión por el café con quienes llegan a nuestra casa en la montaña"
                    </blockquote>
                    <cite>Román Valderrábano, El Catador</cite>
                  </div>
                </div>

                <div className="tours-info-image">
                  <img src={romanImg} alt="Román Valderrábano, El Catador" />
                  <div className="image-badge">
                    <span>🌱</span> Fundada en 1880 - 5 Generaciones
                  </div>
                </div>
              </div>
            </section>
          )}

          {/* Tab Tours Disponibles */}
          {activeTab === 'tours' && (
            <section className="tours-available-section">
              <h2>Experiencias en la Montaña</h2>
              <p>Selecciona la experiencia que más se adapte a tus intereses</p>

              <div style={{background: '#FFF3E0', color: '#E65100', padding: '1rem', borderRadius: '12px', marginBottom: '2rem', borderLeft: '4px solid #E65100', fontWeight: 'bold', fontSize: '0.95rem', textAlign: 'center'}}>
                ⚠️ IMPORTANTE: El costo mínimo para abrir un recorrido o catación es el equivalente a 4 personas.
              </div>

              <div className="tours-cards-grid">
                {toursDisponibles.map(tour => (
                  <div key={tour.id} className="tour-card">
                    <div className="tour-card-image">
                      <img src={tour.imagen} alt={tour.nombre} />
                      {tour.minimo && (
                        <span className="tour-minimo-badge">Mínimo {tour.minimo} personas</span>
                      )}
                    </div>
                    <div className="tour-card-content">
                      <h3>{tour.nombre}</h3>
                      <p className="tour-duracion">⏱️ Duración: {tour.duracion}</p>
                      <ul className="tour-incluye">
                        {tour.incluye.map((item, index) => (
                          <li key={index}>{item}</li>
                        ))}
                      </ul>
                      {tour.nombre !== 'Cocina Tradicional de Humo' && (
                        <div style={{fontSize: '0.85rem', color: '#E57373', fontWeight: 'bold', marginBottom: '1rem'}}>
                          * Aplica cobro mínimo de 4 personas
                        </div>
                      )}
                      <div className="tour-card-footer">
                        <span className="tour-precio">${tour.precio} MXN</span>
                        <button 
                          className="btn-small"
                          onClick={() => {
                            setActiveTab('reserva');
                            if (tour.nombre === 'Tour Completo') {
                              setFormData(prev => ({...prev, includeCatacion: true, includeRecorrido: true}));
                            } else if (tour.nombre === 'Solo Recorrido') {
                              setFormData(prev => ({...prev, includeCatacion: false, includeRecorrido: true}));
                            } else if (tour.nombre === 'Taller de Catación') {
                              setFormData(prev => ({...prev, includeCatacion: true, includeRecorrido: false}));
                            } else if (tour.nombre === 'Cocina Tradicional de Humo') {
                              setFormData(prev => ({...prev, includeBuffet: true}));
                            }
                            setTimeout(() => {
                              document.getElementById('reserva-form')?.scrollIntoView({ behavior: 'smooth' });
                            }, 100);
                          }}
                        >
                          Seleccionar
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* Tab Galería */}
          {activeTab === 'galeria' && (
            <section className="tours-galeria-section">
              <h2>Galería de la Finca</h2>
              <p>Conoce nuestros espacios a través de estas imágenes</p>

              <div className="galeria-grid">
                <div className="galeria-item">
                  <img src={bosqueImg} alt="Bosque mesófilo" />
                  <div className="galeria-caption">Bosque mesófilo de montaña</div>
                </div>
                <div className="galeria-item">
                  <img src={fincaImg} alt="Finca cafetalera" />
                  <div className="galeria-caption">Nuestra finca en la montaña</div>
                </div>
                <div className="galeria-item">
                  <img src={procesadoraImg} alt="Procesadora" />
                  <div className="galeria-caption">Procesadora de café</div>
                </div>
                <div className="galeria-item">
                  <img src={cataImg} alt="Catación" />
                  <div className="galeria-caption">Taller de catación con Román</div>
                </div>
                <div className="galeria-item">
                  <img src={cocinaHumoImg} alt="Cocina de humo" />
                  <div className="galeria-caption">Cocina tradicional de humo</div>
                </div>
                <div className="galeria-item">
                  <img src={xicotepecImg} alt="Xicotepec" />
                  <div className="galeria-caption">Xicotepec de Juárez, Pueblo Mágico</div>
                </div>
              </div>
            </section>
          )}

          {/* Tab Reserva */}
          {activeTab === 'reserva' && (
            <section id="reserva-form" className="tours-reserva-section">
              <div className="reserva-header">
                <h2>Reserva tu Experiencia en la Montaña</h2>
                <p>Completa el formulario y te contactaremos para confirmar</p>
              </div>

              <div className="reserva-grid">
                <div className="reserva-info">
                  <div className="info-card">
                    <h3>📍 Xicotepec de Juárez, Pueblo Mágico</h3>
                    <p>Sierra Norte de Puebla - Bosque Mesófilo de Montaña</p>
                    <ul>
                      <li>🌿 Reservaciones con 48 horas de anticipación</li>
                      <li>👥 Grupos máximos de 15 personas</li>
                      <li>👗 Ropa cómoda y zapatos para caminar</li>
                    </ul>
                  </div>

                  <div className="precios-card">
                    <h3>Tarifas Base</h3>
                    <p style={{fontSize: '0.85rem', color: '#E57373', marginBottom: '1rem', fontWeight: 'bold'}}>
                      ⚠️ IMPORTANTE: El costo mínimo para abrir un recorrido o catación es el equivalente a 4 personas.
                    </p>
                    <div className="precio-item">
                      <span>Tour Completo</span>
                      <span className="precio">$300 MXN / pp</span>
                    </div>
                    <div className="precio-item">
                      <span>Solo Recorrido</span>
                      <span className="precio">$150 MXN / pp</span>
                    </div>
                    <div className="precio-item">
                      <span>Taller de Catación</span>
                      <span className="precio">$200 MXN / pp</span>
                    </div>
                    <div className="precio-item highlight">
                      <span>Cocina Tradicional de Humo</span>
                      <span className="precio">$200 MXN / pp</span>
                    </div>
                    <p className="precio-nota">* La Cocina de humo requiere un mínimo de 10 personas.</p>
                  </div>
                </div>

                <div className="reserva-form-container">
                  <form onSubmit={handleSubmit} className="reserva-form">
                    <div className="form-group">
                      <label>Nombre completo *</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Ej: Juan Pérez García"
                      />
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>Email *</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                          placeholder="correo@ejemplo.com"
                        />
                      </div>
                      <div className="form-group">
                        <label>Teléfono *</label>
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          required
                          placeholder="2281234567"
                        />
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>Fecha preferente *</label>
                        <input
                          type="date"
                          name="date"
                          value={formData.date}
                          onChange={handleInputChange}
                          min={new Date().toISOString().split('T')[0]}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Número de personas asisitiendo *</label>
                        <select
                          name="people"
                          value={formData.people}
                          onChange={handleInputChange}
                          required
                        >
                          {[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15].map(num => (
                            <option key={num} value={num}>{num} {num === 1 ? 'persona' : 'personas'}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name="includeCatacion"
                          checked={formData.includeCatacion}
                          onChange={handleInputChange}
                        />
                        <span>Incluir Taller de Catación con Román ($200 MXN / pp)</span>
                      </label>
                    </div>

                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name="includeRecorrido"
                          checked={formData.includeRecorrido}
                          onChange={handleInputChange}
                        />
                        <span>Incluir Recorrido por el cafetal ($150 MXN / pp)</span>
                      </label>
                    </div>

                    {formData.includeCatacion && formData.includeRecorrido && (
                      <div className="tour-completo-info">
                        ✨ Tour Completo: $300 MXN por persona (Ahorras $50 MXN)
                      </div>
                    )}

                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name="includeBuffet"
                          checked={formData.includeBuffet}
                          onChange={handleInputChange}
                        />
                        <span>Agregar Cocina Tradicional de Humo ($200 MXN extra / pp)</span>
                      </label>
                      {formData.includeBuffet && parseInt(formData.people) < 10 && (
                        <div className="form-warning">
                          ⚠️ La cocina de humo requiere un mínimo de 10 personas para prepararse.
                        </div>
                      )}
                    </div>

                    <div className="form-group">
                      <label>Comentarios adicionales</label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        rows="4"
                        placeholder="¿Alguna pregunta o requerimiento especial?"
                      ></textarea>
                    </div>

                    <div className="resumen-costos">
                      <h4>Resumen de costos estimados:</h4>
                      {(() => {
                        const num = parseInt(formData.people);
                        // Aplicamos cobro mínimo para el Tour
                        const cobroPara = Math.max(4, num); 
                        
                        const catacion = formData.includeCatacion ? 200 * cobroPara : 0;
                        const recorrido = formData.includeRecorrido ? 150 * cobroPara : 0;
                        const tourCompleto = formData.includeCatacion && formData.includeRecorrido ? 300 * cobroPara : catacion + recorrido;
                        const buffet = (formData.includeBuffet && num >= 10) ? 200 * num : 0;
                        
                        const total = tourCompleto + buffet;

                        return (
                          <>
                            <p style={{fontSize: '0.85rem', color: '#E57373', marginBottom: '1rem'}}>
                              * Aplicando tarifa para {cobroPara} personas en el tour.
                            </p>
                            
                            {formData.includeCatacion && !formData.includeRecorrido && <p><span>Taller de Catación:</span> <span>${catacion} MXN</span></p>}
                            {formData.includeRecorrido && !formData.includeCatacion && <p><span>Recorrido en cafetal:</span> <span>${recorrido} MXN</span></p>}
                            {formData.includeCatacion && formData.includeRecorrido && <p><span>Tour Completo:</span> <span>${tourCompleto} MXN</span></p>}
                            
                            {formData.includeBuffet && num >= 10 && <p><span>Cocina de Humo:</span> <span>${buffet} MXN</span></p>}
                            
                            <p className="total"><strong>Total a pagar el día de la visita:</strong> <strong>${total} MXN</strong></p>
                          </>
                        );
                      })()}
                    </div>

                    <button type="submit" className="btn-submit">
                      Enviar Solicitud de Reserva
                    </button>
                  </form>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    </>
  );
};

export default Tours;